// 修正：恢复为简单版本，总是在挂载时聚焦
const focusDirective = {
  /**
   * 当被绑定的元素挂载到 DOM 中时调用
   * @param {HTMLElement} el - 指令所绑定的元素
   */
  mounted(el) {
    // 调用元素的 focus 方法使其获得焦点
    el.focus();
  },
};

export default focusDirective;
